import styled from 'styled-components';

export const FriendsPage = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 0 50px;
    position: relative;
`;

export const Title = styled.h2`
    font-size: 18px;
    color: rgba(255,255,255, 0.5);
    margin-right: 20px;
    text-transform: uppercase;
    font-weight: 100;
`;

export const HeaderRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 50px;
`;

export const ButtonBack = styled.div`
    border: 0px;
    width: 30px;
    min-width: 30px;
    height: 30px;
    min-height: 30px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    transition: color .3s ease 0s;
    margin-right: 10px;

    &:before {
        transition: color .4s ease 0s;
        content: '\\F004D';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'Material Design Icons';
        font-size: 25px;
        color: ${props => props.color};
    }

    &:hover:before {
        color: "#fff";
    }
`;

export const ButtonIcon = styled.div`
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    width: 25px;
    height: 25px;
    min-width: 25px;
    min-height: 25px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: color .3s ease 0s, background-color .3s ease 0s;

    :hover {
        color: ${props => props.hoverColor || '#fff' };
        background-color: ${props => props.color};
    }

    &:not(:last-child) {
        margin-right: 10px;
    }
    
    &:before {
        transition: color .4s ease 0s;
        content: '${props => props.icon}';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'Material Design Icons';
        font-size: 16px;
        color: ${props => props.color};
    }

    &:hover:before {
        color: #000;
    }

    &.yes {
        position: absolute;
        bottom: -5px;
        right: 20px;
    }
    &.no {
        position: absolute;
        bottom: -5px;
        right: 0;
    }
`;

export const Button = styled.div`
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    height: 30px;
    min-height: 30px;
    padding: 0 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    cursor: pointer;
    transition: color .3s ease 0s, background-color .3s ease 0s;

    :hover {
        color: ${props => props.hoverColor || '#fff' };
        background-color: ${props => props.color};
    }
`;

export const Input = styled.input.attrs(()=>({
    type: 'text'
}))`
    background-color: #000;
    border: 1px solid #666;
    height: 30px;
    min-height: 30px;
    width: 200px;
    min-width: 200px;
    box-sizing: border-box;
    padding: 0 5px;
    margin: 0 10px 0 30px;
    color: #fff;
`;

export const Select = styled.select`
    background-color: #000;
    border: 1px solid #666;
    height: 30px;
    min-height: 30px;
    width: 80px;
    min-width: 80px;
    box-sizing: border-box;
    padding: 0 5px;
    margin: 0 10px 0 0;
    color: #fff;
`;


export const FriendItem = styled.div`
    flex: 1;
    min-width: 30%;
    max-width: calc(33% - 20px);
    margin-right: 20px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: stretch;
    cursor: pointer;
    transition: border .4s ease 0s;

    &:nth-child(3n) {
        margin-right: 0;
    }

    
    &.filter0,
    &.filter3,
    &.friend {
        border: 1px solid #999;
    }
    &.filter0:hover,
    &.filter3:hover,
    &.friend:hover {
        border: 1px solid #F5802E;
    }

    &.filter1,
    &.filter2,
    &.pending,
    &.invited {
        border: 1px dashed #999;
    }
    &.filter1:hover,
    &.filter2:hover,
    &.pending:hover,
    &.invited:hover {
        border: 1px dashed #F5802E;
    }

    &.blocked {
        border: 1px dashed #f00;
    }
`;

export const FriendLetter = styled.div.attrs(p => ({
    style: {
        backgroundColor: p.bgColor || '#000',
        color: p.fgColor || '#fff',
    }
}))`
    font-size: 40px;
    height: 80px;
    min-height: 80px;
    width: 80px;
    min-width: 80px;
    margin-right: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 0 15px 0 0;

    &:before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 50%;
        background: #222;
        background: linear-gradient(90deg, rgba(34,34,34,0) 0%, rgba(34,34,34,1) 100%);
    } 
`;

export const FriendData = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
    width: 100%;
`;

export const FriendName = styled.div`
    color: #fff;
    font-size: 16px;
    margin-bottom: 5px;
    transition: color .4s ease 0s;

    ${FriendItem}:hover & {
        color: #F5802E;
    }
`;

export const FriendUsername = styled.div`
    color: #fff;
    font-size: 12px;
    margin-bottom: 15px;
    transition: color .4s ease 0s;

    ${FriendItem}:hover & {
        color: #F5802E;
    }
`;

export const FriendCommonTable = styled.div`
    color: #999;
    font-size: 12px;
    position: relative;
    padding-left: 20px;

    &:before {
        color: #999;
        font-size: 20px;
        content: '\\F000E';
        font-family: 'Material Design Icons';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
`;

export const FriendInvited = styled.div`
    color: #999;
    font-size: 12px;
`;

export const FriendRequest = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-right: 10px;
`;

export const FriendRequestLabel = styled.div`
    color: #999;
    font-size: 12px;
`;

export const FriendRequestButtons = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    position: relative;
`;

export const NoFriends = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #888;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 100px;
    right: 0;

    &:before {
        content: '\\F0010';
        font-family: 'Material Design Icons';
        font-size: 200px;
        color: #444;
    }

    &.noProfiles:before {
        content: '\\F0016';
        font-size: 180px;
        margin-bottom: 30px;
    }

    &.noBlocked:before {
        content: '\\F12DF';
        font-size: 180px;
        margin-bottom: 30px;
    }
`;

export const MessageOk = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    border: 1px solid #5f5;
    color: #5f5;
    background-color: #040;
    padding: 10px;
    margin: 0 50px 20px;
`;

export const FriendsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    position: relative;
    flex: 1;
`;

export const NoUsername = styled.div`
    color: #888;
    font-size: 12px;
`;
